// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4k-2";
export var blackBorderOnHover = "_4k-7";
export var cell = "_4k-6";
export var cellContainer = "_4k-3";
export var checked = "_4k-8";
export var disabled = "_4k-5";
export var featuredIconCellContainer = "_4k-9";
export var featuredIconTextContainer = "_4k-b";
export var featuredIconWrapper = "_4k-a";
export var noBorder = "_4k-c";
export var orangeSelectedRow = "_bv-3";
export var overflowableText = "_4k-0";
export var overflowableTextContainer = "_4k-1";
export var row = "_4m-0";
export var rowCheckboxCell = "_4k-4";
export var selectableTable = "_bv-2";